/**
 * PageContainer — the centred, padded content column.
 *
 * AppLayout's <main> is full-bleed, because a page with a side rail needs its
 * rail flush against the screen edge. Pages without a rail opt back into the
 * padded, max-width column by wrapping themselves in this.
 */
import { cx } from '@lib/classNames';

import styles from './PageContainer.module.css';

export function PageContainer({ className, children }) {
  return <div className={cx(styles.container, className)}>{children}</div>;
}

export default PageContainer;
